import {Input, message, Row} from 'antd';
import {CheckOutlined, CloseOutlined, CopyOutlined, LoadingOutlined} from '@ant-design/icons';
import React from 'react';

import {brandConfig} from '../../../../libs/ui/src';

export function Rb2b({client, loading, latestEvent}) {
  const rb2bLink = `${brandConfig.rb2b_link}?analytics_code=${client.analytics_code}`;
  const isSynchronized = latestEvent && latestEvent.linkedin_url;
  const status = isSynchronized ? (
    <span style={{fontWeight: 'bold'}}>
      <CheckOutlined style={{color: 'var(--color-main-green)', marginLeft: '5px'}} /> synchronized
    </span>
  ) : (
    <span style={{fontWeight: 'bold'}}>
      <CloseOutlined style={{color: 'var(--color-main-red)'}} /> not synchronized
    </span>
  );
  const copyToClibpoard = () => {
    navigator.clipboard.writeText(rb2bLink);
    message.success('Link copied to clipboard');
  };
  return (
    <div>
      {brandConfig.isGx && (
        <p>
          To integrate RB2B, please copy the URL below and paste it on{' '}
          <a href="https://app.rb2b.com/integrations/growthx?ref=gx" target="_blank" rel="noreferrer noopener">
            RB2B
          </a>
          {'. Full instructions '}
          <a
            href="https://help.cuegrowth.ai/en/articles/10258474-how-to-integrate-rb2b-with-growth-x"
            rel="noreferrer noopener"
            target="_blank"
          >
            here
          </a>
          {'.'}
        </p>
      )}
      {!brandConfig.isGx && (
        <p>
          To integrate RB2B please copy the url go to{' '}
          <a href="https://www.rb2b.com?ref=gx" target="_blank" rel="noreferrer noopener">
            rb2b.com
          </a>{' '}
          and follow{' '}
          <a
            href="https://support.rb2b.com/en/articles/8976614-setup-guide-webhook?ref=gx"
            rel="noreferrer noopener"
            target="_blank"
          >
            this instruction.
          </a>
        </p>
      )}
      <Input value={rb2bLink} addonAfter={<CopyOutlined style={{cursor: 'pointer'}} onClick={copyToClibpoard} />} />
      <Row style={{marginTop: 20}}>
        Current status: {loading ? <LoadingOutlined style={{marginLeft: '5px'}} /> : status}
      </Row>
    </div>
  );
}
